export const useAuth = () => {
  const { currentUser, isFetching } = useCurrentUser()

  const isLoggedIn = computed(() => !!currentUser.value)

  return {
    isLoggedIn,
    isFetchingAuthStatus: isFetching,
  }
}
